import React, { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import { getTags, updateTags } from "../../../apis/tags";
import { toastify } from "../../../helperFunctions/toastify";
import { customStringSort } from "../../../helperFunctions/utils";
import DeleteModal from "../../SharedComponents/DeleteModal";
import FilterComponent from "../../SharedComponents/FilterComponent";

export default function Tags() {
	const navigate = useNavigate();
	const [tags, setTags] = useState([]);
	const [filteredData, setFilteredData] = useState([]);
	const [show, setShow] = useState(false);
	const [deleting, setDeleting] = useState("");

	const handleClose = () => {
		setShow(false);
		setDeleting("");
	};

	const getTagsList = async () => {
		const response = await getTags();
		if (response?.status !== "Fail") {
			setTags(response.filter((e) => !e.isDeleted).reverse());
		} else {
			if (response?.message === "No data Found") {
				setTags([]);
			} else {
				toastify(response?.message, "error");
			}
		}
	};

	const removeTag = async () => {
		setShow(false);
		let response = await updateTags(deleting, { isDeleted: true });
		if (response?.status !== "Fail") {
			getTagsList();
			toastify("Tag deleted successfully!", "success");
		} else {
			toastify(response?.message, "error");
		}
	};

	const editSupplier = (e) => {
		navigate("/add-tags", {
			state: {
				tag: e,
			},
		});
	};

	const addSupplier = () => {
		navigate("/add-tags");
	};

	useEffect(() => {
		getTagsList();
	}, []);

	const columns = [
		{
			name: (
				<div className="d-flex align-items-center" id="ovly12">
					<span className="me-2">Name</span>
					{
						<FilterComponent
							type="search"
							array={tags}
							setArray={setFilteredData}
							value="Name"
						/>
					}
				</div>
			),
			selector: (row) => row.name,
			wrap: true,
			sortable: true,
			sortFunction: (a, b) => customStringSort(a, b, "name"),
		},
		{
			name: "Color",
			selector: (row) => row.color,
			wrap: true,
		},

		{
			name: "Description",
			selector: (row) => row.description,
			wrap: true,
			sortable: true,
			sortFunction: (a, b) => customStringSort(a, b, "description"),
		},

		{
			name: "Status",
			selector: (row) => row.status,
			wrap: true,
		},

		{
			name: "Action",
			selector: (row) => row.action,
		},
	];

	const data = (filteredData.length === 0 ? tags : filteredData)?.map(
		(e, index) => {
			return {
				id: e._id,
				name: e.name,
				index: index,
				description: e.description,
				color: (
					<div
						style={{ background: e.color, height: 50, width: 150 }}
					></div>
				),
				status:
					e.isActive === true ? (
						<div className="active-status">Active</div>
					) : (
						<div className="inactive-status">In Active</div>
					),
				action: (
					<div className="d-flex">
						<div
							className="mx-3  cursor-pointer icon-width"
							onClick={() => {
								editSupplier(e);
							}}
						>
							<i className="fa fa-pen"></i>
						</div>
						<div
							className="mx-3  cursor-pointer icon-width"
							onClick={() => {
								setDeleting(e._id);
								setShow(true);
							}}
						>
							<i className="fa fa-trash"></i>
						</div>
					</div>
				),
			};
		},
	);

	const customStyles = {
		headCells: {
			style: {
				justifyContent: "center",
			},
		},
		cells: {
			style: {
				justifyContent: "center",
				textAlign: "center",
			},
		},
	};

	const conditionalRowStyles = [
		{
			when: (row) => row,
			style: {
				borderWidth: "0px",
			},
		},
		{
			when: (row) => row.index % 2 === 1,
			style: {
				borderWidth: "0px",
				backgroundColor: "#f8f8f8",
			},
		},
	];

	return (
		<>
			<div className="container p-0">
				<div className="mainHeading px-4">
					<h1>Tags</h1>
					<Button className="addItem" onClick={addSupplier}>
						+ Add New
					</Button>
				</div>

				<DeleteModal
					content="Confirm Tag Deletion?"
					onYes={removeTag}
					onNo={handleClose}
					show={show}
				/>

				<DataTable
					columns={columns}
					customStyles={customStyles}
					data={data || []}
					pagination
					conditionalRowStyles={conditionalRowStyles}
				/>
			</div>
		</>
	);
}
